import React from 'react'

function Header(props){
	return(<header className="Names"><h2> {props.name} {props.surname}</h2> </header>);
}

export default Header;